// extracted by mini-css-extract-plugin
export default {"ProfileImgContainer":"Gianni_ProfileImgContainer__v-3y9","singleImage":"Gianni_singleImage__M7OKJ"};